import moment from "moment";
import uuidv4 from "uuid/v4";
import { TUpdateServiceRequest } from "../../../../../api/service/apiUpdateService";
import { TUpdateServiceHolderRequest } from "../../../../../api/serviceHolder/apiUpdateServiceHolder";
import { SERVICE_HOLDER_USER_STATUS_ACTIVE } from "../../../../../api/serviceHolder/types";
import {
  SERVICE_HOLDER_HOME_FEATURE_ADAPTED_BATHROOM,
  SERVICE_HOLDER_HOME_FEATURE_ARTICULATED_BED,
  SERVICE_HOLDER_HOME_FEATURE_CAMERAS,
  SERVICE_HOLDER_HOME_FEATURE_CLEAN_SERVICE,
  SERVICE_HOLDER_HOME_FEATURE_CRANE,
  SERVICE_HOLDER_HOME_FEATURE_ELEVATOR,
  SERVICE_HOLDER_HOME_FEATURE_PETS,
  SERVICE_HOLDER_HOME_FEATURE_TELE_ASSISTANCE,
} from "../../../../../util/defaults/serviceHolder";
import {
  TServiceFollowUpForm,
  TServiceFollowUpFormTask,
} from "./ServiceFollowUpForm";

const convertFormDataToHomeFeatruesArray = (
  formData: TServiceFollowUpForm
): string[] => {
  const features: string[] = [];
  if (formData.home_adapted_bathroom) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_ADAPTED_BATHROOM);
  }
  if (formData.home_articulated_bed) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_ARTICULATED_BED);
  }
  if (formData.home_cameras) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_CAMERAS);
  }
  if (formData.home_clean_service) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_CLEAN_SERVICE);
  }
  if (formData.home_crane) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_CRANE);
  }
  if (formData.home_elevator) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_ELEVATOR);
  }
  if (formData.home_pets) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_PETS);
  }
  if (formData.home_tele_asistance) {
    features.push(SERVICE_HOLDER_HOME_FEATURE_TELE_ASSISTANCE);
  }

  return features;
};

const convertFormDataToCommonServiceHolderFields = (
  formData: TServiceFollowUpForm
) => {
  const data = {
    Usuarios_a_cuidar: parseInt(formData.Usuarios_a_cuidar),
    Unidad_de_convivencia: formData.Unidad_de_convivencia,
    Direccion: formData.Direccion,
    Codigo_postal: formData.Codigo_postal,
    Ciudad: formData.Ciudad,
    Region: formData.Region?.value,
    Area: formData.Area?.value,
    Latitud: formData.Latitud ? formData.Latitud + "" : null,
    Longitud: formData.Longitud ? formData.Longitud + "" : null,

    // Estado_U1: formData.Estado_U1?.value,
    Estado_U1: SERVICE_HOLDER_USER_STATUS_ACTIVE,
    Nombre_U1: formData.Nombre_U1,
    Primer_apellido_U1: formData.Primer_apellido_U1,
    Segundo_apellido_U1: formData.Segundo_apellido_U1,
    Fecha_de_nacimiento_U1: undefined as undefined | string,
    DNI_U1: formData.DNI_U1,

    Patologias_U1: formData.Patologias_U1.map((pathology) => pathology?.value),
    Comentarios_patologias_U1: formData.Comentarios_patologias_U1,

    Habla_expresion_U1: formData.Habla_expresion_U1,
    Medicacion_U1: formData.Medicacion_U1,
    Dieta: formData.Dieta,
    Movilidad_U1: formData.Movilidad_U1.map((mobility) => mobility?.value),
    Comentarios_movilidad_U1: formData.Comentarios_movilidad_U1,
    Peso_U1: parseFloat(formData.Peso_U1),
    Altura_U1: parseFloat(formData.Altura_U1),

    Estado_emocional_y_caracter_U1: formData.Estado_emocional_y_caracter_U1.map(
      (status) => status?.value
    ),
    Adaptaci_n_de_cuidados_U1: formData.Adaptaci_n_de_cuidados_U1,
    Comentarios_estado_emocional_y_caracter_U1:
      formData.Comentarios_estado_emocional_y_caracter_U1,
    Actividades_y_aficiones_U1: formData.Actividades_y_aficiones_U1,

    Calidad_del_sue_o_U1: formData.Calidad_del_sue_o_U1?.value,
    Indicaciones_del_sueno_U1: formData.Indicaciones_del_sueno_U1,
    Aseo_U1: formData.Aseo_U1.map((toiletLevel) => toiletLevel?.value),
    Indicaciones_del_aseo_U1: formData.Indicaciones_del_aseo_U1,

    // Estado_U2: formData.Estado_U2?.value,
    Estado_U2:
      formData.Usuarios_a_cuidar === "2"
        ? SERVICE_HOLDER_USER_STATUS_ACTIVE
        : null,
    Nombre_U2: formData.Nombre_U2,
    Primer_apellido_U2: formData.Primer_apellido_U2,
    Segundo_apellido_U2: formData.Segundo_apellido_U2,
    Fecha_de_nacimiento_U2: undefined as undefined | string,
    DNI_U2: formData.DNI_U2,

    Patologias_U2: formData.Patologias_U2.map((pathology) => pathology?.value),
    Comentarios_patologias_U2: formData.Comentarios_patologias_U2,

    Habla_expresion_U2: formData.Habla_expresion_U2,
    Medicacion_U2: formData.Medicacion_U2,
    Dieta_U2: formData.Dieta_U2,
    Movilidad_U2: formData.Movilidad_U2.map((mobility) => mobility?.value),
    Comentarios_movilidad_U2: formData.Comentarios_movilidad_U2,
    Peso_U2: parseFloat(formData.Peso_U2),
    Altura_U2: parseFloat(formData.Altura_U2),

    Estado_emocional_y_caracter_U2: formData.Estado_emocional_y_caracter_U2.map(
      (status) => status?.value
    ),
    Adaptaci_n_de_cuidados_U2: formData.Adaptaci_n_de_cuidados_U2,
    Comentarios_estado_emocional_y_caracter_U2:
      formData.Comentarios_estado_emocional_y_caracter_U2,
    Actividades_y_aficiones_U2: formData.Actividades_y_aficiones_U2,

    Calidad_del_sue_o_U2: formData.Calidad_del_sue_o_U2?.value,
    Indicaciones_del_sueno_U2: formData.Indicaciones_del_sueno_U2,
    Aseo_U2: formData.Aseo_U2.map((toiletLevel) => toiletLevel?.value),
    Indicaciones_del_aseo_U2: formData.Indicaciones_del_aseo_U2,

    Tipo_de_vivienda: formData.Tipo_de_vivienda,
    Caracteristicas_de_la_vivienda: undefined as undefined | string[],
    Proveedor_de_Teleasistencia: formData.Proveedor_de_Teleasistencia,

    Comunicacion_con_transporte_publico:
      formData.Comunicacion_con_transporte_publico,
    Notas_coordinadora: formData.Notas_coordinadora,

    Source: "Affinity",
    Lead_External_ID: formData.Lead_External_ID,
    Referente_B2B: formData.Referente_B2B ? formData.Referente_B2B.id : null,

    lastFollowUpAt: moment().toISOString(),
    Pregunta_podologia: formData.Pregunta_podologia,
    Pregunta_consejos_medicos: formData.Pregunta_consejos_medicos,
    Pregunta_comida_saludable: formData.Pregunta_comida_saludable,
    Pregunta_estimulacion: formData.Pregunta_estimulacion,
    Pregunta_CuideoAssist: formData.Pregunta_CuideoAssist,
  };

  const birthDate = moment(formData.Fecha_de_nacimiento_U1);
  if (birthDate.isValid()) {
    data.Fecha_de_nacimiento_U1 = birthDate.format("YYYY-MM-DD");
  } else {
    delete data.Fecha_de_nacimiento_U1;
  }

  const birthDate2 = moment(formData.Fecha_de_nacimiento_U2);
  if (birthDate2.isValid()) {
    data.Fecha_de_nacimiento_U2 = birthDate2.format("YYYY-MM-DD");
  } else {
    delete data.Fecha_de_nacimiento_U2;
  }

  const homeFeatures = convertFormDataToHomeFeatruesArray(formData);
  data.Caracteristicas_de_la_vivienda = homeFeatures;

  return data;
};

const convertFormDataToUpdateServiceHolder = (
  serviceHolderId: string,
  formData: TServiceFollowUpForm
): TUpdateServiceHolderRequest => {
  const data = {
    ...convertFormDataToCommonServiceHolderFields(formData),
  } as TUpdateServiceHolderRequest;

  return data;
};

const convertFormDataToUpdateService = (
  serviceId: string,
  serviceHolderId: string,
  formData: TServiceFollowUpForm
): TUpdateServiceRequest => {
  const data: TUpdateServiceRequest = {
    Seguimiento_datetime: moment().toISOString(),
  };

  return data;
};

const prepareServiceFollowUpTasks = (
  serviceId: string,
  formData: TServiceFollowUpForm
) => {
  const tasks = [] as TServiceFollowUpFormTask[];
  let serviceHolderId = formData.service_holder_id;
  let lastId = 1;

  tasks.push({
    id: lastId++,
    name: "update_service_holder",
    status: "pending",
    serviceHolder: convertFormDataToUpdateServiceHolder(
      serviceHolderId,
      formData
    ),
  });

  formData.Contactos.forEach((contact) => {
    if (contact.op === "new_relation_existing_contact" && contact.contact_id) {
      let newRelationshipId = uuidv4();
      tasks.push({
        id: lastId++,
        name: "new_relation_existing_contact",
        status: "pending",
        relationship: {
          id: newRelationshipId,
          Contacto: contact.contact_id,
          Usuario: serviceHolderId,
          Parentesco: contact.Parentesco,
        },
      });
    }
    if (contact.op === "new_relation_new_contact") {
      let newRelationshipId = uuidv4();
      let newContactId = uuidv4();
      tasks.push({
        id: lastId++,
        name: "new_relation_new_contact",
        status: "pending",
        contact: {
          id: newContactId,
          First_Name: contact.First_Name,
          Last_Name: contact.Last_Name,
          Phone: contact.Phone,
          Email: contact.Email,
          Business_Country: "es",
        },
        relationship: {
          id: newRelationshipId,
          Contacto: newContactId,
          Usuario: serviceHolderId,
          Parentesco: contact.Parentesco,
        },
      });
    }
    if (contact.op === "existing_relation_remove" && contact.id) {
      tasks.push({
        id: lastId++,
        name: "existing_relation_remove",
        status: "pending",
        relationshipId: contact.id,
      });
    }
    if (contact.op === "modify_existing_relation" && contact.id) {
      tasks.push({
        id: lastId++,
        name: "modify_existing_relation",
        status: "pending",
        relationshipId: contact.id,
        relationship: {
          Parentesco: contact.Parentesco,
        },
      });
    }
  });

  tasks.push({
    id: lastId++,
    name: "update_service",
    status: "pending",
    service: convertFormDataToUpdateService(
      serviceId,
      serviceHolderId,
      formData
    ),
  });

  return tasks;
};

export { prepareServiceFollowUpTasks };
